/**
 * Merci : le prix d'une ligne d'upsell suit la taille choisie dans sa liste.
 * Markup et raisons dans `snippets/merci-upsell-row.liquid`.
 *
 * Chaque option porte son prix déjà formaté (`data-prix`) et, s'il y en a un,
 * son prix barré (`data-prix-barre`) : on reconstruit le prix avec le markup de
 * `snippets/price.liquid` — prix barré puis prix soldé, chacun précédé de son
 * libellé masqué — sans refaire de format monétaire ici.
 *
 * **Une écoute sur le document**, et non par ligne : les lignes des
 * recommandations arrivent après le chargement, par un rendu de section, et
 * peuvent être remplacées. L'écoute les voit toutes, présentes et à venir.
 */

/**
 * @param {string} classe
 * @param {string} libelle
 * @param {string} montant
 */
function groupe(classe, libelle, montant) {
  const span = document.createElement('span');
  span.className = classe;
  const masque = document.createElement('span');
  masque.className = 'visually-hidden';
  masque.textContent = `${libelle} `;
  span.append(masque, montant);
  return span;
}

document.addEventListener('change', (event) => {
  const liste = event.target;
  if (!(liste instanceof HTMLSelectElement) || !liste.closest('.merci-upsell-row__select')) return;

  const option = liste.selectedOptions[0];
  const zone = liste.closest('.merci-upsell-row')?.querySelector('.merci-upsell-row__price');
  const conteneur = zone?.querySelector('[ref="priceContainer"]');
  if (!option?.dataset.prix || !(zone instanceof HTMLElement) || !conteneur) return;

  const { prix, prixBarre } = option.dataset;
  const nouveaux = prixBarre
    ? [
        groupe('price-item__group price-item--regular compare-at-price', zone.dataset.libelleNormal || '', prixBarre),
        groupe('price-item__group price', zone.dataset.libelleSolde || '', prix),
      ]
    : [Object.assign(document.createElement('span'), { className: 'price', textContent: prix })];

  // Seuls les prix sont remplacés : un éventuel prix unitaire reste en place.
  conteneur.querySelectorAll(':scope > .price, :scope > .compare-at-price').forEach((element) => element.remove());
  conteneur.prepend(...nouveaux);
});
